// src/context/index.js
/* eslint-disable react/prop-types */
import React, { createContext, useContext, useMemo, useReducer, useEffect } from "react";

// ----- Estado inicial (oscuro por defecto) -----
const readPersisted = () => {
  try {
    const raw = localStorage.getItem("darkMode");
    if (raw === null) return true; // <== oscuro como default
    return raw === "true";
  } catch {
    return true;
  }
};

const initialState = {
  miniSidenav: false,
  transparentSidenav: false,
  whiteSidenav: false,
  sidenavColor: "warning",
  transparentNavbar: true,
  fixedNavbar: true,
  openConfigurator: false,
  direction: "ltr",
  layout: "dashboard",
  darkMode: readPersisted(),
};

// ----- Reducer -----
function reducer(state, action) {
  switch (action.type) {
    case "MINI_SIDENAV":        return { ...state, miniSidenav: action.value };
    case "TRANSPARENT_SIDENAV": return { ...state, transparentSidenav: action.value };
    case "WHITE_SIDENAV":       return { ...state, whiteSidenav: action.value };
    case "SIDENAV_COLOR":       return { ...state, sidenavColor: action.value };
    case "TRANSPARENT_NAVBAR":  return { ...state, transparentNavbar: action.value };
    case "FIXED_NAVBAR":        return { ...state, fixedNavbar: action.value };
    case "OPEN_CONFIGURATOR":   return { ...state, openConfigurator: action.value };
    case "DIRECTION":           return { ...state, direction: action.value };
    case "LAYOUT":              return { ...state, layout: action.value };
    case "DARKMODE":            return { ...state, darkMode: action.value };
    default: return state;
  }
}

// ----- Contexto -----
const MaterialUI = createContext();
MaterialUI.displayName = "MaterialUIContext";

// ----- Provider -----
export function MaterialUIControllerProvider({ children }) {
  const [controller, dispatch] = useReducer(reducer, initialState);

  // Persistir y aplicar clase al <body> cuando cambia el modo
  useEffect(() => {
    try { localStorage.setItem("darkMode", String(controller.darkMode)); } catch {}
    document.body.classList.toggle("theme-dark", controller.darkMode);
  }, [controller.darkMode]);

  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);

  return <MaterialUI.Provider value={value}>{children}</MaterialUI.Provider>;
}

// ----- Hook -----
export function useMaterialUIController() {
  const context = useContext(MaterialUI);
  if (!context) throw new Error("useMaterialUIController debe usarse dentro de MaterialUIControllerProvider");
  return context;
}

// ----- Setters “action creators” -----
export const setMiniSidenav        = (dispatch, value) => dispatch({ type: "MINI_SIDENAV", value });
export const setTransparentSidenav = (dispatch, value) => dispatch({ type: "TRANSPARENT_SIDENAV", value });
export const setWhiteSidenav       = (dispatch, value) => dispatch({ type: "WHITE_SIDENAV", value });
export const setSidenavColor       = (dispatch, value) => dispatch({ type: "SIDENAV_COLOR", value });
export const setTransparentNavbar  = (dispatch, value) => dispatch({ type: "TRANSPARENT_NAVBAR", value });
export const setFixedNavbar        = (dispatch, value) => dispatch({ type: "FIXED_NAVBAR", value });
export const setOpenConfigurator   = (dispatch, value) => dispatch({ type: "OPEN_CONFIGURATOR", value });
export const setDirection          = (dispatch, value) => dispatch({ type: "DIRECTION", value });
export const setLayout             = (dispatch, value) => dispatch({ type: "LAYOUT", value });
export const setDarkMode           = (dispatch, value) => dispatch({ type: "DARKMODE", value });
